import dataArea from './dataArea.vue'
const _dataArea = {
    install:function(Vue){
        Vue.component('WtDataArea',dataArea)
    }
}
export default _dataArea


// WEBPACK FOOTER //
// ./src/components/dataArea/dataArea.js